import { APIFetchStudio, RequestHeaders } from "@certa/network";
import { useMutation, type UseMutationOptions } from "react-query";

type GetAppJSONParams = {
  branchSavepointId: number;
  paths?: string[];
};

// app_json value is depends on the path so can not be typed
type GetAppJSONRawResponse = { app_json: any };
type GetAppJSONResponse = any;

export function getAppJSON({
  branchSavepointId,
  paths
}: GetAppJSONParams): Promise<GetAppJSONResponse> {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: paths ? JSON.stringify({ paths }) : "{}"
  };

  return APIFetchStudio<GetAppJSONRawResponse>(
    `branch-savepoint/${branchSavepointId}/get-app-json/`,
    requestOptions
  ).then(res => res.app_json);
}

export const useGetAppJSONMutation = (
  extraConfig?: UseMutationOptions<
    GetAppJSONResponse,
    { error: string },
    GetAppJSONParams,
    unknown
  >
) => useMutation(getAppJSON, extraConfig);
